<template>
  <div class="enroll-fail">
    <div class="fail">
      <div v-if="showFailReason">
        <p class="title">未通过原因：</p>
        <p>{{text}}</p>
        <div class="convert" v-if="showNormalConvertBlock">
          <p class="title">由于您的个人信息审核已通过，推荐转为无车加入，可直接进入面试环节。</p>
          <router-link tag="p" class="link" :to="nocarUrl">了解无车加入方式 ></router-link>
        </div>
        <div class="convert" v-if="showCompanyConvertBlock">
          <p class="title">由于您的个人信息审核已通过，推荐转为企业无车加入，可直接进入面试环节。</p>
          <router-link tag="p" class="link" :to="companyNocarUrl">了解企业无车加入方式 ></router-link>
        </div>
        <div class="convert" v-if="showCompanyConvertToNormalBlock">
          <template v-if="showCompanyConvertToNormalNocar">
            <p class="title">经神州平台复核，推荐转为个人无车加入，{{followStatusText}}</p>
            <router-link tag="p" class="link" :to="nocarUrl">了解无车加入方式 ></router-link>
          </template>
          <template v-else>
            <p class="title">经神州平台复核，推荐转为个人带车加入，{{followStatusText}}</p>
            <router-link tag="p" class="link" :to="hascarUrl">了解带车加入方式 ></router-link>
          </template>
        </div>
      </div>
      <p v-else>很抱歉，由于您{{vuexJoinMode === 2 ? failReasonForCompany[status] : failReason[status]}}，本次报名失败。感谢关注神州专车。</p>
    </div>
    <div class="enroll-fail-footer">
      <ucar-button size="full" :class="{'re-try': enableConvert}" @click="submit">重新报名</ucar-button>
      <ucar-button size="full" v-if="showNormalConvertBlock" @click="convert">转为无车加入</ucar-button>
      <ucar-button size="full" v-if="showCompanyConvertBlock" @click="convert">转企业无车加入</ucar-button>
      <ucar-button size="full" v-if="showCompanyConvertToNormalBlock" @click="convert">{{companyConvertButtonText}}</ucar-button>
    </div>
  </div>
</template>

<script>
import { failReason, failReasonForCompany } from '../utils/enroll-status'
import { mapGetters, mapActions } from 'vuex'
import { convertToNocar, convertToNormal } from '../api'
import { loginStatusMixin } from '../mixins'
export default {
  name: 'enroll-fail',
  mixins: [loginStatusMixin],
  data () {
    return {
      failReason,
      failReasonForCompany,
      nocarUrl: '/introduction/nocar?mode=nobtn',
      hascarUrl: '/introduction/hascar?mode=nobtn'
    }
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    isFulltime: {
      type: Boolean,
      default: true
    },
    status: {
      type: Number,
      default: 0
    },
    showFailReason: {
      type: Boolean,
      default: true
    },
    enableConvert: {
      type: Boolean,
      default: false
    },
    driverReviewStatus: {
      type: Number,
      default: 0
    },
    carReviewStatus: {
      type: Number,
      default: 0
    },
    timeout: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'vuexRegType',
      'vuexJoinMode',
      'vuexIndexUrl',
      'vuexRecruitId',
      'vuexCompanyId',
      'vuexDisapproveInfo',
      'vuexCurrentCity'
    ]),
    currentCityAllowNocar () {
      // 当前城市允许无车报名
      const { noCar, rentCar, buyCar } = this.vuexCurrentCity
      return noCar !== 0 || rentCar !== 0 || buyCar !== 0
    },
    currentCityAllowHascar () {
      // 当前城市允许带车报名
      return this.vuexCurrentCity.hasCar !== 0
    },
    needModify () {
      // 司机复核状态与车辆复核状态任一为退回修改则为需要修改
      return this.driverReviewStatus === 2 || this.carReviewStatus === 2
    },
    companyNocarUrl () {
      return `/company-introduction?type=nocar&mode=nobtn`
    },
    followStatusText () {
      return this.needModify ? '确认并修改不合格图片后可进入平台审核环节。' : '可直接进入面试环节'
    },
    showNormalConvertBlock () {
      // 加盟模式为个人加盟且且可以转无车，并且未超时
      return this.currentCityAllowNocar && this.vuexJoinMode === 1 && this.enableConvert
    },
    showCompanyConvertBlock () {
      // 加盟模式为企业加盟且状态为审核未通过且可以转无车，并且未超时
      return this.vuexJoinMode === 2 && this.status === 906 && this.enableConvert
    },
    showCompanyConvertToNormalBlock () {
      // 加盟模式为企业加盟且司机复核状态为通过或退回修改且状态不是审核未通过，并且未超时
      return !this.timeout && ((this.currentCityAllowHascar && [1, 2].indexOf(this.carReviewStatus) !== -1) || this.currentCityAllowNocar) && this.vuexJoinMode === 2 && [1, 2].indexOf(this.driverReviewStatus) !== -1 && this.status !== 906
    },
    showCompanyConvertToNormalNocar () {
      // 车辆复核状态为未通过或加盟方式为企业无车
      return (this.currentCityAllowNocar && this.carReviewStatus === 0) || this.vuexRegType === '4'
    },
    companyConvertButtonText () {
      return this.carReviewStatus === 0 || this.vuexRegType === '4' ? this.needModify ? '修改并转个人无车' : '转个人无车加入' : this.needModify ? '修改并转个人带车' : '转个人带车加入'
    }
  },
  methods: {
    ...mapActions([
      'setVuexCompanyId'
    ]),
    submit () {
      this.$emit('reTry')
    },
    convert () {
      if (this.needModify) {
        // 去修改之前需要先转换登录状态为修改信息
        this.changeStatusToModifyInfo()
        const url = this.vuexDisapproveInfo.errorType === 2 ? '/car-info' : '/person-info'
        this.$router.push(`${url}?mode=modify`)
        return
      }
      // 当企业转个人时调用convertToNormal, 当企业转企业，个人转个人时调用convertToNocar
      if (!this.showCompanyConvertBlock) this.setVuexCompanyId('setVuexCompanyId', '')
      if (this.showNormalConvertBlock || this.showCompanyConvertBlock) {
        convertToNocar(this.vuexRecruitId).then(() => {
          this.$emit('refresh')
        })
      } else {
        convertToNormal(this.vuexRecruitId).then(() => {
          this.$emit('refresh')
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";
.enroll-fail {
  flex: 1 0 auto;
  display: flex;
  flex-flow: column nowrap;

  .fail {
    flex: 1 0 auto;
    background-color: #fff;
    padding: 60px $ucar_side_gutter;
    .title {
      font-weight: 700;
      margin-bottom: 30px;
    }
    .error-msg {
      margin-bottom: 30px;
    }
    .convert {
      margin-top: 160px;

      .title {
        margin-bottom: 24px;
      }

      .link {
        text-decoration: none;
        color: $ucar_price_color;
      }
    }
  }
  .enroll-fail-footer {
    padding: 30px 0;
    display: flex;
  }
  .re-try {
    background-color: #fffaf4;
    border: 1PX solid #dbac6f;
    color: #D0964b;
  }
}
</style>
